import * as microsoftTeams from "@microsoft/teams-js";
import { useEffect, useState } from "react";
import axios from "axios";
import showConsentDialog from "../../../utils/show-consent-dialog";
import jwt_decode from "jwt-decode";
import { ICT_INTERNAL_TENANTS } from "../../../constants/ict-internal-tenants";

export default function Login() {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState();
  const [needsConsent, setNeedsConsent] = useState(false);

  const addLog = (msg: string) => {
    // console.log(msg);
  };

  const ssoLoginSuccess = async (result: string) => {
    addLog("✅ Teams getAuthToken thành công. Bắt đầu exchange...");
    await exchangeClientTokenForServerToken(result);
  };

  const ssoLoginFailure = (error: string) => {
    addLog("❌ Teams getAuthToken thất bại: " + error);
    setLoading(false);
  };

  // call when rendering the component
  // initLoginToken(ssoLoginSuccess,ssoLoginFailure, setCurrentUser, setLoading).catch(error => console.error(error));
  useEffect(() => {
    addLog("🚀 Bắt đầu useEffect. Đang gọi microsoftTeams.app.initialize()...");
    microsoftTeams.app
      .initialize()
      .then(() => {
        addLog(
          "✅ Initialize thành công. Khởi tạo getContext và getAuthToken...",
        );

        microsoftTeams.app
          .getContext()
          .then((context: microsoftTeams.app.Context) => {
            addLog(
              "✅ Lấy được context của user: " +
                context?.user?.userPrincipalName,
            );
            setCurrentUser(context?.user as any);
          });

        microsoftTeams.authentication
          .getAuthToken()
          .then(async (result: string) => {
            await ssoLoginSuccess(result);
            setLoading(false);
            addLog("🚀 Chuẩn bị điều hướng sang thẻ Portal...");
            microsoftTeams.pages.currentApp.navigateTo({
              pageId: "ict24h.m365.tabs.portal",
            });
          })
          .catch((error: string) => {
            ssoLoginFailure(error);
          });
      })
      .catch((err) => {
        addLog("❌ Lỗi khi khởi tạo Teams App: " + JSON.stringify(err));
        setLoading(false);
      });
  }, []);

  async function exchangeClientTokenForServerToken(clientToken: string) {
    addLog("🔑 Bắt đầu gọi server để đổi token...");
    let tidFromToken = undefined;
    try {
      const decodedToken: any = jwt_decode(clientToken);
      if (decodedToken && decodedToken.tid) {
        tidFromToken = decodedToken.tid;
      }
    } catch (e) {
      addLog("⚠️ Lỗi giải mã token bằng jwt-decode");
    }

    const headers: Record<string, string> = {};

    if (tidFromToken === ICT_INTERNAL_TENANTS.cenprecast.tid) {
      headers["i24h-tenant"] = ICT_INTERNAL_TENANTS.cenprecast.i24hTenant;
    }

    let data: any = null;
    try {
      const response = await axios.post(
        "https://approval.zbh-dev.i24h.app/auth/login-ms-obh",
        { token: clientToken, clientId: process.env.REACT_APP_MSAL_APP_ID },
        { headers },
      );
      data = response.data;
      addLog(
        "✅ Gọi API thành công: " +
          JSON.stringify(data).substring(0, 100) +
          "...",
      );
    } catch (e: any) {
      if (e.response && e.response.data) {
        data = e.response.data;
        addLog(
          "⚠️ Server trả về mã lỗi 4xx/5xx: " +
            JSON.stringify(data).substring(0, 100) +
            "...",
        );
      } else {
        addLog("❌ Lỗi kết nối API: " + e.message);
      }
    }

    if (
      data?.error &&
      (data?.error[0]?.response?.errrorCode === "consent_required" ||
        data?.error[0]?.response?.errorCode === "consent_required" ||
        data?.error === "consent_required")
    ) {
      addLog("⚠️ Đã phát hiện yêu cầu consent!");
      setNeedsConsent(true);
    } else if (
      data?.errorCode === "consent_required" ||
      data?.errrorCode === "consent_required"
    ) {
      addLog("⚠️ Đã phát hiện yêu cầu consent!");
      setNeedsConsent(true);
    } else if (data) {
      addLog("ℹ️ Token exchange data: Không thấy báo lỗi consent_required.");
    }
  }

  const handleConsentClick = async () => {
    try {
      const result = await showConsentDialog();
      console.log("Consent success: ", result);
      // Try to re-authenticate or just navigate
      microsoftTeams.pages.currentApp.navigateTo({
        pageId: "ict24h.m365.tabs.portal",
      });
    } catch (error) {
      console.error("Consent failed: ", error);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      {loading ? (
        <div>
          <h3>Đang xử lý đăng nhập...</h3>
        </div>
      ) : (
        <>
          {currentUser && (currentUser as any).userPrincipalName ? (
            <p>
              ✅ Trạng thái: Đã có tài khoản -{" "}
              {(currentUser as any).userPrincipalName}
            </p>
          ) : (
            <p>Tài khoản chưa có thông tin Principal Name (lỗi ngữ cảnh).</p>
          )}

          {needsConsent ? (
            <div style={{ marginTop: 20 }}>
              <p>
                ⚠️{" "}
                <b>Ứng dụng cần bạn cấp quyền truy cập vào Cổng thông tin.</b>
              </p>
              <button
                onClick={handleConsentClick}
                style={{
                  padding: "10px 20px",
                  background: "#0078d4",
                  color: "#fff",
                  border: "none",
                }}
              >
                Cấp quyền ứng dụng ngay
              </button>
            </div>
          ) : (
            <div style={{ marginTop: 20 }}>
              <button onClick={showConsentDialog}>
                Mở cửa sổ xác thực thủ công
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
